import styled from '@emotion/styled';

export const AZContactStep = styled.div`
  .ant-select {
    width: 100%;
  }
`;
